import { useState } from "react"
import { Button, Flex, Form, Input } from "antd"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { createCategory } from "store/trips"
import { Modal } from "ui/Modal"
import { Text } from "ui/Typography"
import styles from "./AddCategoryModal.module.css"

export const AddCategoryModal = ({ open, onClose, onConfirm }) => {
  const dispatch = useDispatch()
  const [value, setValue] = useState("")
  const [isError, setIsError] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleConfirm = async () => {
    const trimmed = value.trim()
    if (!trimmed) {
      setIsError(true)
      return
    }
    setIsSubmitting(true)
    const result = await dispatch(createCategory(trimmed))
    setIsSubmitting(false)
    const category = result?.data?.category
    if (category) {
      onConfirm(category)
      setValue("")
      setIsError(false)
    }
  }

  const handleClose = () => {
    setValue("")
    setIsError(false)
    onClose()
  }

  const handleChange = (e) => {
    setValue(e.target.value)
    if (isError) setIsError(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleConfirm()
  }

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title={"Add new category"}
      width={480}
      footer={
        <Flex gap={8} justify="flex-end">
          <Button shape="round" size="large" onClick={handleClose} disabled={isSubmitting}>{"Cancel"}</Button>
          <Button shape="round" size="large" type="primary" loading={isSubmitting} onClick={handleConfirm}>{"Create"}</Button>
        </Flex>
      }
    >
      <Form layout="vertical">
        <Form.Item
          label={<Text fw={500}>{"Category"}<span className={styles.required}>*</span></Text>}
          validateStatus={isError ? "error" : ""}
          help={isError ? "Category name is required" : ""}
        >
          <Input
            className={styles.input}
            placeholder={"ex. Fishing"}
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            size="large"
            autoFocus
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

AddCategoryModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
}
